import React from 'react';
import CompleteRegistrationRequestEmailSentSection from "../../components/incomplete-registration-section/CompleteRegistrationRequestEmailSentSection";

const CompleteRegistrationRequestEmailSent = (props) => (
    <CompleteRegistrationRequestEmailSentSection {...props}/>
);

export default CompleteRegistrationRequestEmailSent;